export const SET_STAMPS = "setStamps";
export const SET_STAMPS_TOTAL = "setStampsTotal";
export const SET_STAMP = "setStamp";
export const SET_LOADING = "setLoading";

export default {
  [SET_STAMPS](state, supervisor_stamps) {
    state.supervisor_stamps = supervisor_stamps;
  },
  [SET_STAMPS_TOTAL](state, totalCount) {
    state.totalCount = totalCount;
  },
  [SET_STAMP](state, supervisor_stamp) {
    state.supervisor_stamp = supervisor_stamp;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};
